import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
const TOKEN_KEY = "santral_access_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); };
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token from localStorage so auth survives iOS Safari ITP / cross-site cookie blocks
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Public
export const fetchProperties = (params = {}) => api.get("/properties", { params }).then((r) => r.data);
export const fetchProperty = (slug) => api.get(`/properties/${slug}`).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);

// Auth
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const createSession = async (session_id) => {
  const d = await api.post("/auth/session", { session_id }).then((r) => r.data);
  if (d?.session_token) setToken(d.session_token);
  return d;
};
export const passwordLogin = async (email, password) => {
  const d = await api.post("/auth/login", { email, password }).then((r) => r.data);
  if (d?.access_token) setToken(d.access_token);
  return d;
};
export const changePassword = (current_password, new_password) =>
  api.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);
export const logout = async () => { try { await api.post("/auth/logout"); } finally { clearToken(); } };

// WebAuthn (Face ID / Touch ID / Fingerprint)
export const waCheckEnabled = (email) => api.get(`/auth/webauthn/enabled`, { params: { email } }).then((r) => r.data);
export const waRegisterBegin = () => api.post("/auth/webauthn/register/begin").then((r) => r.data);
export const waRegisterVerify = (payload) => api.post("/auth/webauthn/register/verify", payload).then((r) => r.data);
export const waLoginBegin = (email) => api.post("/auth/webauthn/login/begin", { email }).then((r) => r.data);
export const waLoginVerify = async (payload) => {
  const d = await api.post("/auth/webauthn/login/verify", payload).then((r) => r.data);
  if (d?.access_token) setToken(d.access_token);
  return d;
};
export const waListCredentials = () => api.get("/auth/webauthn/credentials").then((r) => r.data);
export const waDeleteCredential = (id) => api.delete(`/auth/webauthn/credentials/${encodeURIComponent(id)}`).then((r) => r.data);

// Admin
export const adminListProps = () => api.get("/admin/properties").then((r) => r.data);
export const adminCreate = (data) => api.post("/admin/properties", data).then((r) => r.data);
export const adminUpdate = (id, data) => api.put(`/admin/properties/${id}`, data).then((r) => r.data);
export const adminDelete = (id) => api.delete(`/admin/properties/${id}`).then((r) => r.data);
export const updateProfile = (payload) => api.put("/auth/profile", payload).then((r) => r.data);
export const listAdmins = () => api.get("/admin/users").then((r) => r.data);
export const createAdmin = (payload) => api.post("/admin/users", payload).then((r) => r.data);
export const removeAdmin = (user_id) => api.delete(`/admin/users/${user_id}`).then((r) => r.data);
